﻿import { defineStore } from 'pinia';

export const summaryErrorsUpdatedEventName = 'softools:summary-errors-updated';

export interface SummaryErrorsUpdatedEventDetail {
    messages: string[];
}

export function dispatchSummaryErrorsUpdated(messages: string[]): void {
    if (typeof window === 'undefined') {
        return;
    }

    window.dispatchEvent(new CustomEvent<SummaryErrorsUpdatedEventDetail>(
        summaryErrorsUpdatedEventName,
        {
            detail: {
                messages: [...messages]
            }
        }
    ));
}

export const useSummaryErrorsStore = defineStore('summaryErrorsModule', {
    state: () => ({
        _summaryErrorMessages: [] as string[]
    }),
    getters: {
        errorCount: state => state._summaryErrorMessages.length,
        hasSummaryErrors(): boolean {
            return this.errorCount > 0;
        },
        summaryErrorMessages: state => state._summaryErrorMessages
    },
    actions: {
        setSummaryErrorMessages(payload: string[]): void {
            this._summaryErrorMessages.splice(0, this._summaryErrorMessages.length, ...payload);
            dispatchSummaryErrorsUpdated(this._summaryErrorMessages);
        },
        addSummaryErrorMessage(payload: string): void {
            const messageAlreadyExists = this._summaryErrorMessages.find(o => o === payload) !== undefined;
            if (!messageAlreadyExists) {
                this._summaryErrorMessages.push(payload);
                dispatchSummaryErrorsUpdated(this._summaryErrorMessages);
            }
        },
        clearSummaryErrorMessages(): void {
            this._summaryErrorMessages.splice(0, this._summaryErrorMessages.length, ...[]);
            dispatchSummaryErrorsUpdated(this._summaryErrorMessages);
        },
        clearSummaryErrorMessagesThatContain(payload: string): void {
            const filteredErrors = this._summaryErrorMessages.filter(o => o.indexOf(payload) === -1);

            this._summaryErrorMessages.splice(0, this._summaryErrorMessages.length, ...filteredErrors);
            dispatchSummaryErrorsUpdated(this._summaryErrorMessages);
        }
    }
});

export type SummaryErrorsModule = ReturnType<typeof useSummaryErrorsStore>;

export default useSummaryErrorsStore;
